import React, { useState } from "react";
import RLogo from "../Assets/Rumiz_logo.svg";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="nav-container">
      <div className="nav-logo-group">
        <img src={RLogo} alt="Roommy Logo" className="nav-logo" />
      </div>
      <div className="navbar-burger" onClick={() => setMenuOpen((open) => !open)}>
        <span className="burger-bar"></span>
        <span className="burger-bar"></span>
        <span className="burger-bar"></span>
      </div>
      <div className={`navbar-links-group${menuOpen ? " open" : ""}`}>
        <a href="#features-section" className="nav-link" onClick={() => setMenuOpen(false)}>תכונות</a>
        <a href="#how-it-works-section" className="nav-link" onClick={() => setMenuOpen(false)}>איך זה עובד</a>
        <a href="#accuracy-section" className="nav-link" onClick={() => setMenuOpen(false)}>דיוק</a>
        <button className="download-button" onClick={() => setMenuOpen(false)}>הורדה</button>
      </div>
    </nav>
  );
};

export default Navbar;
